import { render } from "./water-tariff-view.vue?vue&type=template&id=b0c0db58&scoped=true"
import script from "./water-tariff-view.vue?vue&type=script&setup=true&lang=js"
export * from "./water-tariff-view.vue?vue&type=script&setup=true&lang=js"

import "./water-tariff-view.vue?vue&type=style&index=0&id=b0c0db58&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0c0db58"],['__file',"src/views/mped/views/waterTariffSetupView/water-tariff-view.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b0c0db58"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b0c0db58', __exports__)) {
    api.reload('b0c0db58', __exports__)
  }
  
  module.hot.accept("./water-tariff-view.vue?vue&type=template&id=b0c0db58&scoped=true", () => {
    api.rerender('b0c0db58', render)
  })

}


export default __exports__